import { todayISODate } from "../utils/homepageSeason";

export const isBeforeFirstSquad = (status, today = todayISODate()) =>
  Boolean(status?.firstSquadDate && status.firstSquadDate > today);

export const isOnOrAfterFirstSquad = (status, today = todayISODate()) =>
  !status?.firstSquadDate || status.firstSquadDate <= today;

export const listTournamentStatus = (
  tournament,
  { resultsVerified = false, allowSignups = false, today = todayISODate() } = {}
) => {
  if (resultsVerified) return "Standings Available";

  const liveSquads = (tournament.squads || []).filter(
    (squad) => !squad.isDeleted
  );
  if (liveSquads.length === 0) return "Tournament Setup";

  const dates = liveSquads
    .map((squad) => squad.squadDate)
    .filter(Boolean)
    .sort();
  const first = dates[0] || tournament.startDate;
  const last = dates[dates.length - 1] || tournament.startDate;

  if (!first) return "Tournament Setup";
  if (dates.includes(today) || (first <= today && last >= today)) {
    return "Tournament Active";
  }
  if (first > today) return allowSignups ? "Registration Open" : "Upcoming";
  return "Processing Standings";
};

export const getPublicProgressSteps = (status) => {
  if (!status) return [];

  const scoresComplete = Boolean(status.allTeamScoresComplete);
  const started = Boolean(status.hasSquads) && isOnOrAfterFirstSquad(status);
  const registrationLabel = status.allowSignups
    ? "Registration Open"
    : "Upcoming";

  return [
    {
      key: "tournamentSetup",
      label: "Tournament Setup",
      inProgressLabel: "Setting Up Tournament",
      description: "Events, fees, and squads",
      isComplete: Boolean(status.hasSquads),
    },
    {
      key: "registrationOpen",
      label: registrationLabel,
      inProgressLabel: registrationLabel,
      description: status.allowSignups
        ? "Accepting online signups"
        : "Squads are set. Bowling starts on tournament day.",
      isComplete: started || scoresComplete,
    },
    {
      key: "tournamentActive",
      label: "Tournament Active",
      inProgressLabel: "Tournament Active",
      description: "Bowling and scoring in progress",
      isComplete: scoresComplete,
    },
    {
      key: "scoreProcessing",
      label: "Processing Standings",
      inProgressLabel: "Processing Standings",
      description: "Calculating final standings",
      isComplete: Boolean(status.resultsFinalized),
    },
    {
      key: "resultsAvailable",
      label: "Standings Available",
      inProgressLabel: "Standings Available",
      description: "Final standings posted",
      isComplete: Boolean(status.resultsFinalized),
    },
  ];
};
